import { useContext, useState, useRef } from 'react';
import Collection from '@/utils/api/odas/collection';
import { languageContext } from '@/context/language.context';
import { isSuccessResponse, HTTP_STATUS, STANDARD_ERROR_MESSAGE } from '@/constants/httpStatus';
import t from '@/utils/Language/UI-translations';
import useHoneybadger from '@/hooks/useHoneybadger';

export const useLoadCollection = ({ addToast, router }) => {
  const [collection, setCollection] = useState({});
  const [loading, setLoading] = useState(true);
  const loadedSlugRef = useRef(null);
  const { notifyHoneybadger } = useHoneybadger();
  const { currentLanguage } = useContext(languageContext);

  const loadCollection = ({ slug, categoriesOnly = false } = {}) => {
    if (!slug) return Promise.resolve();

    const params = {
      get_counts: true,
      include_owner_org: true,
      list_only: true,
      show_permissions_for_user: true,
      show_team_ids: true,
      locale: currentLanguage
    };

    return Collection.loadCollectionBySlug(slug, params)
      .then((resp) => {
        if (isSuccessResponse(resp.status)) {
          if (categoriesOnly) {
            setCollection((prev) => ({
              ...prev,
              categories: resp?.data?.collection?.categories
            }));
          } else {
            setCollection(resp?.data?.collection);
            loadedSlugRef.current = slug;
            try {
              sessionStorage.setItem(`col_${slug}`, JSON.stringify(resp?.data?.collection));
            } catch (e) {}
          }
          setLoading(false);
        } else {
          setLoading(false);
          const responseStatus = resp?.status || resp?.response?.status;
          if (responseStatus === HTTP_STATUS.UNAUTHORIZED) {
            addToast({ message: t('You do not have permission to view this collection.'), type: 'warning' });
            router.push('/collections');
          } else if (responseStatus === HTTP_STATUS.NOT_FOUND) {
            notifyHoneybadger('Collection not found', {
              message: 'Collection not found',
              component: 'useLoadCollection',
              context: {
                slug,
                responseStatus
              }
            });
            addToast({ type: 'error' });

            router.push('/collections');
          } else {
            addToast({ type: 'error' });
          }
          throw new Error();
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return { collection, setCollection, loading, setLoading, loadCollection, loadedSlugRef };
};
